var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { ref: "link", on: { click: _vm.clicked } }, [
    _c("li", [
      _c("span", [_vm._v(_vm._s(_vm.name))]),
      _vm._v(" "),
      _vm.count != null
        ? _c("span", { staticClass: "count" }, [
            _vm._v("(" + _vm._s(_vm.count) + ")"),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }